/* G-TIDE — movimiento sutil: progreso de lectura, encabezado, foco de luz e inclinación de tarjetas */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Barra de progreso y encabezado al desplazarse */
  const bar = document.createElement('div');
  bar.className = 'gt-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  const header = document.querySelector('.header-wrapper');
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty('--p', max > 0 ? (window.scrollY / max).toFixed(4) : 0);
      if (header) header.classList.toggle('is-scrolled', window.scrollY > 24);
      ticking = false;
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (reduceMotion || !finePointer) return;

  /* Foco de luz en el banner */
  document.querySelectorAll('.gt-hero').forEach((hero) => {
    hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      hero.style.setProperty('--mx', `${e.clientX - r.left}px`);
      hero.style.setProperty('--my', `${e.clientY - r.top}px`);
      hero.style.setProperty('--spot', 1);
    });
    hero.addEventListener('pointerleave', () => hero.style.setProperty('--spot', 0));
  });

  /* Inclinación 3D leve en tarjetas de producto y de categoría */
  const tilt = (el) => {
    if (el.dataset.tilt) return;
    el.dataset.tilt = 'true';
    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width;
      const y = (e.clientY - r.top) / r.height;
      el.style.setProperty('--ry', `${((x - 0.5) * 6).toFixed(2)}deg`);
      el.style.setProperty('--rx', `${((0.5 - y) * 6).toFixed(2)}deg`);
      el.style.setProperty('--gx', `${(x * 100).toFixed(1)}%`);
      el.style.setProperty('--gy', `${(y * 100).toFixed(1)}%`);
    });
    el.addEventListener('pointerleave', () => {
      el.style.setProperty('--rx', '0deg');
      el.style.setProperty('--ry', '0deg');
    });
  };
  const init = (root = document) => root.querySelectorAll('.card, .gt-cat').forEach(tilt);
  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  // las tarjetas que llegan al filtrar una colección
  new MutationObserver(() => init()).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
})();
